<section class="task-detail-content-root" [class.page-context]="context === 'page'">

    <!-- ============ HEADER ============ -->
    <div class="scraii-task-mgmt-dialog-header mb-2">
        <div class="scraii-task-mgmt-dialog-title">
            {{ contentTitle }}
        </div>

        <!-- ============ TOP TOGGLE BUTTONS ============ -->
        <div class="d-flex justify-content-center my-2 px-3 position-relative">

            <span class="scraii-task-mgmt-dialog-widContainers">
                <div class="d-flex justify-content-between">
                    <button *ngFor="let item of items" type="button" (click)="changeDisplayType(item.value)" [ngClass]="{
                            'scraii-task-mgmt-dialog-highlight': selectedType === item.value
                        }" class="scraii-task-mgmt-dialog-cycleHover" [disabled]="item.value === 2 && isCreateMode">
                        {{ item.title }}<span *ngIf="item.value === 1 && comments.length > 0"
                            class="tab-count">&nbsp;({{ comments.length }})</span><span
                            *ngIf="item.value === 2 && taskAttachments.length > 0" class="tab-count">&nbsp;({{
                            taskAttachments.length }})</span>
                    </button>
                </div>
            </span>
        </div>

        <button *ngIf="context === 'dialog'" class="dialog-header-close" mat-icon-button (click)="cancelled.emit()">
            <mat-icon>close</mat-icon>
        </button>
    </div>



    <!-- ============ TASK DETAILS ============ -->
    <ng-container *ngIf="selectedType === 0">

        <!-- Parent Case Info Banner (subtask creation only) -->
        <div class="parent-task-info-banner" *ngIf="parentTaskInfo">
            <span class="parent-task-info-label">Parent Case:</span>
            <span class="parent-task-info-name">{{ parentTaskInfo.taskName }}</span>
            <span class="parent-task-info-type" *ngIf="parentTaskInfo.taskType">{{
                getTaskTypeLabel(parentTaskInfo.taskType) }}</span>
            <span class="parent-task-info-status" [ngClass]="'parent-status-' + statusKeyFor(parentTaskInfo.status)">{{
                getStatusLabel(parentTaskInfo.status) }}</span>
            <span class="parent-task-info-priority"
                [ngClass]="'parent-priority-' + priorityKeyFor(parentTaskInfo.priorityLevel)">{{
                getPriorityLevelLabel(parentTaskInfo.priorityLevel) }}</span>
            <span class="parent-task-info-assignee" *ngIf="parentTaskInfo.assignTo">{{
                getAssignToLabel(parentTaskInfo.assignTo) }}</span>
        </div>

        <div class="task-detail-body" id="task_mgmt_id">

            <!-- The form is always visible in both Create and Edit modes.
                 The old read-only "view mode" block has been removed — the
                 dialog now opens directly in edit mode. -->
            <form [formGroup]="taskForm" class="flex-grow-1 d-flex flex-column">

                <!-- 1. TASK NAME + TASK TYPE — paired half/half -->
                <div class="field-row">
                    <div class="field">
                        <mat-label>Case Name</mat-label>
                        <mat-form-field appearance="outline" class="full-width">
                            <input matInput formControlName="taskName" #taskNameInput />
                            <!-- <mat-error *ngIf="taskForm.get('taskName')?.hasError('required')">
                                Case name is required
                            </mat-error> -->
                        </mat-form-field>
                    </div>

                    <div class="field">
                        <mat-label>Case Type</mat-label>
                        <mat-form-field appearance="outline" class="full-width">
                            <mat-select formControlName="taskType" panelClass="tmd-select-panel">
                                <mat-option *ngFor="let t of taskTypeOptions" [value]="t.value">
                                    {{ optionLabelOf(t) }}
                                </mat-option>
                            </mat-select>
                            <!-- <mat-error *ngIf="taskForm.get('taskType')?.hasError('required')">
                                Case type is required
                            </mat-error> -->
                        </mat-form-field>
                    </div>
                </div>

                <!-- 2. DESCRIPTION -->
                <div class="field">
                    <mat-label>Description</mat-label>
                    <mat-form-field appearance="outline" class="full-width">
                        <textarea matInput rows="3" formControlName="description"></textarea>
                    </mat-form-field>
                </div>

                <!-- 3. STATUS + PRIORITY -->
                <div class="field-row">
                    <div class="field">
                        <mat-label>Case Status</mat-label>
                        <mat-form-field appearance="outline"
                            class="full-width scraii-task-mgmt-dialog-status-pill-field">
                            <mat-select formControlName="status" panelClass="tmd-select-panel">
                                <mat-select-trigger>
                                    <span class="scraii-task-mgmt-dialog-status-dot"
                                        [ngClass]="statusKeyFor(taskForm.get('status')?.value)"></span>
                                    <span class="scraii-task-mgmt-dialog-status-pill-text">
                                        {{ getStatusLabel(taskForm.get('status')?.value) }}
                                    </span>
                                </mat-select-trigger>
                                <mat-option *ngFor="let s of statusOptions" [value]="s.value">
                                    <span class="scraii-task-mgmt-dialog-status-dot"
                                        [ngClass]="statusKeyFor(s.value)"></span>
                                    {{ optionLabelOf(s) }}
                                </mat-option>
                            </mat-select>
                            <!-- <mat-error *ngIf="taskForm.get('status')?.hasError('required')">
                                Status is required
                            </mat-error> -->
                        </mat-form-field>
                    </div>

                    <div class="field">
                        <mat-label>Priority</mat-label>
                        <mat-form-field appearance="outline"
                            class="full-width scraii-task-mgmt-dialog-priority-pill-field">
                            <mat-select formControlName="priorityLevel" panelClass="tmd-select-panel">
                                <mat-select-trigger>
                                    <span class="scraii-task-mgmt-dialog-priority-dot"
                                        [ngClass]="priorityKeyFor(taskForm.get('priorityLevel')?.value)"></span>
                                    <span class="scraii-task-mgmt-dialog-priority-pill-text">
                                        {{ getPriorityLevelLabel(taskForm.get('priorityLevel')?.value) }}
                                    </span>
                                </mat-select-trigger>
                                <mat-option *ngFor="let p of priorityLevelOptions" [value]="p.value">
                                    <span class="scraii-task-mgmt-dialog-priority-dot"
                                        [ngClass]="priorityKeyFor(p.value)"></span>
                                    {{ optionLabelOf(p) }}
                                </mat-option>
                            </mat-select>
                            <!-- <mat-error *ngIf="taskForm.get('priorityLevel')?.hasError('required')">
                                Priority is required
                            </mat-error> -->
                        </mat-form-field>
                    </div>
                </div>

                <!-- 4. START + END DATE -->
                <div class="field-row">
                    <div class="field">
                        <mat-label>Start Date</mat-label>
                        <mat-form-field appearance="outline" class="full-width">
                            <input matInput [matDatepicker]="startPicker" formControlName="startDate">
                            <mat-datepicker-toggle matSuffix [for]="startPicker">
                                <mat-icon matDatepickerToggleIcon>
                                    <svg width="14" height="15" viewBox="0 0 14 15" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M12.75 6.08333H0.75M9.41667 0.75V3.41667M4.08333 0.75V3.41667M3.95 14.0833H9.55C10.6701 14.0833 11.2302 14.0833 11.658 13.8653C12.0343 13.6736 12.3403 13.3676 12.532 12.9913C12.75 12.5635 12.75 12.0034 12.75 10.8833V5.28333C12.75 4.16323 12.75 3.60318 12.532 3.17535C12.3403 2.79903 12.0343 2.49307 11.658 2.30132C11.2302 2.08333 10.6701 2.08333 9.55 2.08333H3.95C2.8299 2.08333 2.26984 2.08333 1.84202 2.30132C1.46569 2.49307 1.15973 2.79903 0.967987 3.17535C0.75 3.60318 0.75 4.16323 0.75 5.28333V10.8833C0.75 12.0034 0.75 12.5635 0.967987 12.9913C1.15973 13.3676 1.46569 13.6736 1.84202 13.8653C2.26984 14.0833 2.8299 14.0833 3.95 14.0833Z"
                                            stroke="#1363DF" stroke-width="1.5" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                </mat-icon>
                            </mat-datepicker-toggle>
                            <mat-datepicker #startPicker></mat-datepicker>
                        </mat-form-field>
                    </div>

                    <div class="field">
                        <mat-label>End Date</mat-label>
                        <mat-form-field appearance="outline" class="full-width">
                            <input matInput [matDatepicker]="endPicker" formControlName="endDate" [min]="taskForm.get('startDate')?.value">
                            <mat-datepicker-toggle matSuffix [for]="endPicker">
                                <mat-icon matDatepickerToggleIcon>
                                    <svg width="14" height="15" viewBox="0 0 14 15" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M12.75 6.08333H0.75M9.41667 0.75V3.41667M4.08333 0.75V3.41667M3.95 14.0833H9.55C10.6701 14.0833 11.2302 14.0833 11.658 13.8653C12.0343 13.6736 12.3403 13.3676 12.532 12.9913C12.75 12.5635 12.75 12.0034 12.75 10.8833V5.28333C12.75 4.16323 12.75 3.60318 12.532 3.17535C12.3403 2.79903 12.0343 2.49307 11.658 2.30132C11.2302 2.08333 10.6701 2.08333 9.55 2.08333H3.95C2.8299 2.08333 2.26984 2.08333 1.84202 2.30132C1.46569 2.49307 1.15973 2.79903 0.967987 3.17535C0.75 3.60318 0.75 4.16323 0.75 5.28333V10.8833C0.75 12.0034 0.75 12.5635 0.967987 12.9913C1.15973 13.3676 1.46569 13.6736 1.84202 13.8653C2.26984 14.0833 2.8299 14.0833 3.95 14.0833Z"
                                            stroke="#1363DF" stroke-width="1.5" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                </mat-icon>
                            </mat-datepicker-toggle>
                            <mat-datepicker #endPicker></mat-datepicker>
                        </mat-form-field>
                    </div>
                </div>

                <!-- 6. REMIND ME TOGGLE + DATE & TIME FIELDS -->
                <div class="field remind-me-wrap">
                    <div class="scraii-task-mgmt-dialog-remind-label-row">
                        <mat-label>Remind Me</mat-label>
                        <mat-slide-toggle formControlName="remindMe"></mat-slide-toggle>
                    </div>

                    <div class="remind-fields-row" *ngIf="taskForm.get('remindMe')?.value">
                        <div class="remind-field-col">
                            <!-- <label class="lbl">Remind Date</label> -->
                            <mat-form-field appearance="outline" class="full-width">
                                <input matInput [matDatepicker]="remindPicker" [min]="remindMinDate"
                                    formControlName="remindDate" placeholder="Pick date">
                                <mat-datepicker-toggle matSuffix [for]="remindPicker">
                                    <mat-icon matDatepickerToggleIcon>
                                        <svg width="14" height="15" viewBox="0 0 14 15" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12.75 6.08333H0.75M9.41667 0.75V3.41667M4.08333 0.75V3.41667M3.95 14.0833H9.55C10.6701 14.0833 11.2302 14.0833 11.658 13.8653C12.0343 13.6736 12.3403 13.3676 12.532 12.9913C12.75 12.5635 12.75 12.0034 12.75 10.8833V5.28333C12.75 4.16323 12.75 3.60318 12.532 3.17535C12.3403 2.79903 12.0343 2.49307 11.658 2.30132C11.2302 2.08333 10.6701 2.08333 9.55 2.08333H3.95C2.8299 2.08333 2.26984 2.08333 1.84202 2.30132C1.46569 2.49307 1.15973 2.79903 0.967987 3.17535C0.75 3.60318 0.75 4.16323 0.75 5.28333V10.8833C0.75 12.0034 0.75 12.5635 0.967987 12.9913C1.15973 13.3676 1.46569 13.6736 1.84202 13.8653C2.26984 14.0833 2.8299 14.0833 3.95 14.0833Z"
                                                stroke="#1363DF" stroke-width="1.5" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                        </svg>
                                    </mat-icon>
                                </mat-datepicker-toggle>
                                <mat-datepicker #remindPicker></mat-datepicker>
                            </mat-form-field>
                        </div>

                        <div class="remind-field-col">
                            <!-- <label class="lbl">Remind Time</label> -->
                            <mat-form-field appearance="outline" class="full-width">
                                <mat-select formControlName="remindTime" placeholder="Pick time" panelClass="tmd-select-panel">
                                    <mat-option *ngFor="let opt of remindTimeOptions; trackBy: trackRemindOpt"
                                        [value]="opt.value" [disabled]="disabledRemindTimes.has(opt.value)">
                                        {{ opt.label }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <div class="field-error" *ngIf="isRemindTimeInPast">
                                Selected time is in the past. Pick a later slot or change the date.
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 7. ASSIGN TO — searchable user dropdown -->
                <div class="field">
                    <label class="lbl">Assign To <span class="req">*</span></label>
                    <div class="assignee-search-wrap">
                        <input #assigneeSearchInput class="tag-search-input" type="text"
                            placeholder="Search user by name..." autocomplete="off" [(ngModel)]="assigneeInput"
                            [ngModelOptions]="{ standalone: true }" (focus)="onAssigneeSearchFocus()"
                            (input)="onAssigneeSearchInput($event)" (blur)="onAssigneeSearchBlur()" />
                    </div>

                    <div #assigneeResultsDropdown class="assignee-results-dropdown" [class.open]="showAssigneeResults">
                        <div *ngIf="isSearchingUsers" class="assignee-results-loading">
                            <span class="tag-spinner"></span> Loading users…
                        </div>
                        <div *ngIf="!isSearchingUsers && assigneeSearchResults.length === 0 && showAssigneeResults"
                            class="assignee-results-empty">
                            No users found
                        </div>
                        <div *ngFor="let user of assigneeSearchResults" class="assignee-result-item"
                            [class.already-added]="isUserAlreadySelected(user)"
                            (mousedown)="$event.preventDefault(); onUserResultSelect(user)">
                            <div class="assignee-result-body">
                                <div class="assignee-result-name">{{ user.usr_display_nm || user.user_id }}</div>
                                <div class="assignee-result-sub">{{ user.user_id }}</div>
                            </div>
                            <span *ngIf="isUserAlreadySelected(user)" class="assignee-result-check">&#10003;</span>
                            <button *ngIf="!isUserAlreadySelected(user)" class="assignee-result-add-btn"
                                type="button">+</button>
                        </div>
                    </div>

                    <div class="assignee-chips" *ngIf="getFormAssignees().length > 0">
                        <div *ngFor="let email of getFormAssignees(); let i = index" class="assignee-chip">
                            <span>{{ getAssigneeDisplayName(email) }}</span>
                            <button type="button" class="assignee-chip-x" (click)="removeAssignee(i)">×</button>
                        </div>
                    </div>
                    <div class="field-error"
                        *ngIf="taskForm.get('assignees')?.touched && taskForm.get('assignees')?.hasError('minArrayLength')">
                        At least one assignee is required
                    </div>
                </div>

                <!-- 8. TAG TYPE — chip single-select, driven by /api/tag-categories/get-all -->
                <div class="field">
                    <label class="lbl">Tag Type <span class="req">*</span></label>

                    <!-- Skeleton while categories load -->
                    <div class="tag-type-skeleton" *ngIf="isLoadingTagCategories">
                        <div class="skeleton-chip"></div>
                        <div class="skeleton-chip"></div>
                        <div class="skeleton-chip"></div>
                    </div>

                    <!-- Real chips after the lookup is hydrated.
                         When isTagTypeLocked (opened from a patient/HCP row), only the
                         pre-selected chip is shown enabled and it cannot be changed. -->
                    <div class="tag-type-chips" *ngIf="!isLoadingTagCategories && tagCategories.length > 0">
                        <button *ngFor="let cat of tagCategories; let i = index" type="button" class="tag-type-chip"
                            [class.active]="taskForm.get('tagType')?.value === cat.tag_category_id"
                            [disabled]="isTagTypeLocked && taskForm.get('tagType')?.value !== cat.tag_category_id"
                            [style.cursor]="isTagTypeLocked ? 'not-allowed' : 'pointer'"
                            [style.--chip-color]="getCategoryColor(i)" (click)="onTagTypeChipSelect(cat)">
                            {{ cat.category_name }}
                        </button>
                    </div>

                    <!-- API responded but list is empty — surface that explicitly -->
                    <div *ngIf="!isLoadingTagCategories && tagCategories.length === 0" class="field-hint">
                        No tag categories available
                    </div>

                    <div class="field-error"
                        *ngIf="taskForm.get('tagType')?.touched && taskForm.get('tagType')?.hasError('required')">
                        Please select a tag type
                    </div>
                </div>

                <!-- 9. SEARCH & TAG — only shown once a tag type chip is selected.
                     Disabled (not hidden) when the tag is locked (sidebar / single-row
                     context): the entity is fixed to that row, so no search/change. -->
                <div class="field" *ngIf="taskForm.get('tagType')?.value">
                    <label class="lbl">Search &amp; Tag <span class="req">*</span></label>
                    <div class="tag-search-wrap">
                        <input #tagSearchInput class="tag-search-input" type="text"
                            [placeholder]="getTagSearchPlaceholder()" autocomplete="off"
                            [disabled]="isTagTypeLocked"
                            [style.cursor]="isTagTypeLocked ? 'not-allowed' : 'text'"
                            (input)="onTagSearchInput($event)" (blur)="onTagSearchBlur()"
                            (keydown.escape)="clearTagSearch()" />
                    </div>

                    <!-- Fixed-position results dropdown — positioned by JS so it can
                         escape the dialog's overflow:hidden. -->
                    <div #tagResultsDropdown class="tag-results-dropdown" [class.open]="showTagResults">

                        <div *ngIf="isSearchingTags" class="tag-results-loading">
                            <span class="tag-spinner"></span> Searching…
                        </div>

                        <div *ngIf="!isSearchingTags && tagSearchResults.length === 0 && showTagResults"
                            class="tag-results-empty">
                            No results found
                        </div>

                        <div *ngFor="let tag of tagSearchResults" class="tag-result-item"
                            [class.already-added]="isTagAlreadySelected(tag)"
                            (mousedown)="$event.preventDefault(); onTagResultSelect(tag)">
                            <div class="tag-result-body">
                                <div class="tag-result-name">{{ tag.tag_name }}</div>
                                <div class="tag-result-sub">{{ tag.category_name || activeTagCategoryName }}</div>
                            </div>
                            <span *ngIf="isTagAlreadySelected(tag)" class="tag-result-check">✓</span>
                            <button *ngIf="!isTagAlreadySelected(tag)" class="tag-result-add-btn"
                                type="button">+</button>
                        </div>
                    </div>
                </div>

                <!-- 10. SELECTED ENTITY CHIPS -->
                <div class="field" *ngIf="taskForm.get('tagType')?.value && selectedEntityLinks.length > 0">
                    <div class="entity-chips">
                        <div *ngFor="let entity of selectedEntityLinks; let i = index" class="entity-chip"
                            [style.background]="getEntityChipBg(entity)"
                            [style.border-color]="getEntityChipBorder(entity)"
                            [style.color]="getEntityChipText(entity)">
                            <span class="entity-chip-label">{{ entity.category }}</span>
                            <span>{{ entity.name }}</span>
                            <!-- Disabled in locked (sidebar) mode — the single
                                 preset entity must stay tagged to the row. -->
                            <button class="entity-chip-x" [disabled]="isTagTypeLocked"
                                [style.cursor]="isTagTypeLocked ? 'not-allowed' : 'pointer'"
                                (click)="removeTagEntity(i)" type="button">×</button>
                        </div>
                    </div>
                </div>

                <!-- 11. TAGS VALIDATION ERROR
                     Two variants depending on whether a tag type was picked:
                       - Tag type set → "Please select at least one tag"
                       - Tag type missing → combined message (the tagType field
                         already shows its own required error above; this is
                         the catch-all when both are empty). -->
                <div class="field"
                    *ngIf="taskForm.get('tags')?.touched && taskForm.get('tags')?.hasError('minArrayLength')">
                    <div class="field-error" *ngIf="taskForm.get('tagType')?.value">
                        Please select at least one tag
                    </div>
                    <div class="field-error" *ngIf="!taskForm.get('tagType')?.value">
                        Please select a tag type and at least one tag
                    </div>
                </div>

            </form>

        </div>

        <!-- FOOTER BUTTONS (visible only on the Details tab because the
             entire enclosing ng-container is `*ngIf="selectedType === 0"`).
             A single dynamic button handles both create and update — there
             is no separate "Complete Case" button any more (users change
             status via the dropdown and click the same save button). -->
        <div class="task-detail-actions gap-2 mt-2">
            <button class="scraii-secondary-btn" type="button" (click)="cancelled.emit()">
                Cancel
            </button>

            <button class="scraii-primary-btn" type="button" [disabled]="taskForm.invalid" (click)="onSave()">
                {{ isCreateMode ? 'Create Case' : 'Update Case' }}
            </button>
        </div>

    </ng-container>

    <!-- ============ TASK UPDATES ============ -->
    <ng-container *ngIf="selectedType === 1">

        <div class="task-detail-body" id="task_mgmt_id" #updatesFeedContainer>
            <div class="scraii-task-mgmt-dialog-updates-view">

                <!-- Description card -->
                <div class="tmud-description-card" *ngIf="taskForm.get('description')?.value">
                    {{ taskForm.get('description')?.value }}
                </div>

                <!-- Status dropdown (table-view only) -->
                <div class="tmud-status-row" *ngIf="showStatusDropdown">
                    <mat-label>Case Status</mat-label>
                    <mat-form-field appearance="outline"
                        class="tmud-status-field scraii-task-mgmt-dialog-status-pill-field">
                        <mat-select [formControl]="$any(taskForm.controls['status'])" panelClass="tmd-select-panel">
                            <mat-select-trigger>
                                <span class="scraii-task-mgmt-dialog-status-dot"
                                    [ngClass]="statusKeyFor(taskForm.get('status')?.value)"></span>
                                <span class="scraii-task-mgmt-dialog-status-pill-text">
                                    {{ getStatusLabel(taskForm.get('status')?.value) }}
                                </span>
                            </mat-select-trigger>
                            <mat-option *ngFor="let s of statusOptions" [value]="s.value">
                                <span class="scraii-task-mgmt-dialog-status-dot"
                                    [ngClass]="statusKeyFor(s.value)"></span>
                                {{ optionLabelOf(s) }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <!-- ====================================================
                     Comments timeline — replaces the old hardcoded updates
                     array. Lazy-loaded on tab click via changeDisplayType(1)
                     → loadCommentsIfNeeded(). API: api/tasks/comments/get.
                     ==================================================== -->

                <!-- Loading state -->
                <div *ngIf="isLoadingComments" class="updates-loading">
                    <mat-spinner diameter="20"></mat-spinner>
                    <span>Loading comments…</span>
                </div>

                <!-- Create mode — task hasn't been saved yet -->
                <div *ngIf="!isLoadingComments && !getTaskId()" class="updates-empty">
                    Save the case first to add comments.
                </div>

                <!-- Empty state for saved tasks -->
                <div *ngIf="!isLoadingComments && getTaskId() && comments.length === 0" class="updates-empty">
                    No comments yet — add the first one below.
                </div>

                <!-- Comments list -->
                <div class="updates-list" *ngIf="!isLoadingComments && getTaskId() && comments.length > 0">
                    <div *ngFor="let comment of comments" class="update-entry">
                        <div class="update-avatar">{{ getCommentInitials(comment.created_by) }}</div>
                        <div class="update-content">
                            <div class="update-meta">
                                <span class="update-author">{{ comment.created_by }}</span>
                                <span class="update-time" [matTooltip]="getFullTimestamp(comment.created_time)">
                                    {{ getRelativeTime(comment.created_time) }}
                                </span>
                            </div>

                            <!-- Normal (read) view -->
                            <div class="update-text-wrap" *ngIf="editingCommentId !== comment.task_update_id">
                                <div class="update-text">{{ comment.comment_text }}</div>
                                <div *ngIf="comment.attachments?.length > 0" class="update-attachments">
                                    <div *ngFor="let att of comment.attachments" class="update-att-chip">
                                        <mat-icon class="att-icon">attach_file</mat-icon>
                                        <span>{{ att.file_name || att.name || 'Attachment' }}</span>
                                    </div>
                                </div>
                            </div>

                            <!-- Inline edit view -->
                            <div class="update-edit-wrap" *ngIf="editingCommentId === comment.task_update_id">
                                <textarea class="update-edit-ta" [(ngModel)]="editingCommentText"
                                    [ngModelOptions]="{ standalone: true }" rows="3"
                                    (keydown.escape)="cancelEditComment()"></textarea>
                                <div class="update-edit-actions">
                                    <button type="button" class="scraii-secondary-btn"
                                        (click)="cancelEditComment()">Cancel</button>
                                    <button type="button" class="scraii-primary-btn" (click)="saveEditComment(comment)"
                                        [disabled]="!editingCommentText.trim() || isSavingEdit">
                                        {{ isSavingEdit ? 'Saving…' : 'Save' }}
                                    </button>
                                </div>
                            </div>

                            <!-- Row actions (edit/delete — all users can edit/delete any comment) -->
                            <div class="update-actions" *ngIf="editingCommentId !== comment.task_update_id">
                                <button type="button" class="update-action-btn"
                                    (click)="startEditComment(comment)">Edit</button>
                                <button type="button" class="update-action-btn delete" (click)="deleteComment(comment)"
                                    [disabled]="isDeletingCommentId === comment.task_update_id">
                                    {{ isDeletingCommentId === comment.task_update_id ? 'Deleting…' : 'Delete' }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <!-- Comment composer — pinned at the bottom of the Updates tab (outside
             the scrollable .task-detail-body) via the parent flex column layout. -->
        <div class="task-detail-actions tmud-actions-bar">
            <div class="footer-composer">
                <div class="footer-composer-input-wrap">
                    <textarea class="footer-composer-input" [formControl]="$any(updateForm.controls['message'])"
                        placeholder="Write a comment... (Shift+Enter for new line)" rows="1" maxlength="2000"
                        (input)="onComposerInput($event)" (keydown)="onComposerKeydown($event)">
                    </textarea>
                </div>
                <button type="button" class="scraii-primary-btn mb-2 footer-composer-btn"
                    [disabled]="!updateForm.get('message')?.value?.trim() || isPostingComment || !getTaskId()"
                    (click)="onAddUpdate()">
                    <span class="tmud-add-update-label" [style.visibility]="isPostingComment ? 'hidden' : 'visible'">
                        Add Update
                    </span>
                    <mat-spinner *ngIf="isPostingComment" diameter="14" class="footer-composer-spinner"></mat-spinner>
                </button>
            </div>
        </div>

    </ng-container>

    <!-- ============ ATTACHMENTS ============ -->
    <!-- Lazy-loaded on first switch to this tab (changeDisplayType(2) →
         loadAttachmentsIfNeeded) AND auto-loaded in ngOnInit when the caller
         passes initialTab === 2 (e.g. the kanban-card attachment icon). -->
    <ng-container *ngIf="selectedType === 2">
        <div class="task-detail-body" id="task_mgmt_id">
            <div class="attachments-view">

                <!-- Loading state -->
                <div *ngIf="isLoadingAttachments" class="att-loading">
                    <mat-spinner diameter="20"></mat-spinner>
                    <span>Loading attachments…</span>
                </div>

                <!-- Create mode — task hasn't been saved yet -->
                <div *ngIf="!isLoadingAttachments && !getTaskId()" class="att-empty">
                    Save the case first to add attachments.
                </div>

                <!-- Drop zone (edit mode) -->
                <div *ngIf="!isLoadingAttachments && getTaskId()" class="att-drop-zone" [class.drag-over]="isDragOver"
                    (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onFileDrop($event)"
                    (click)="attFileInput.click()">
                    <input #attFileInput type="file" multiple hidden (change)="onAttachmentInputChange($event)" />
                    <mat-icon class="att-drop-icon">cloud_upload</mat-icon>
                    <div class="att-drop-title">Click or drag &amp; drop files here</div>
                    <div class="att-drop-sub">Attach documents, images, spreadsheets, PDFs</div>
                    <div class="att-drop-limit">Max 50 MB per file</div>
                </div>

                <!-- Upload progress (while a batch is in flight) -->
                <div *ngIf="isUploadingFile" class="att-upload-progress">
                    <mat-progress-bar mode="determinate" [value]="uploadProgress"></mat-progress-bar>
                    <span class="att-upload-label">Uploading… {{ uploadProgress }}%</span>
                </div>

                <!-- File list -->
                <div *ngIf="!isLoadingAttachments && taskAttachments.length > 0" class="att-list">
                    <div class="att-section-title">Files ({{ taskAttachments.length }})</div>
                    <div *ngFor="let att of taskAttachments" class="att-item">
                        <div class="att-item-thumb">
                            <mat-icon>{{ getFileIcon(att.file_name) }}</mat-icon>
                        </div>
                        <div class="att-item-info">
                            <div class="att-item-name" [matTooltip]="att.file_name">{{ att.file_name }}</div>
                            <div class="att-item-meta">
                                <span *ngIf="att.file_size">{{ formatFileSize(att.file_size) }}</span>
                                <span *ngIf="att.uploaded_by">by {{ att.uploaded_by }}</span>
                                <span *ngIf="att.uploaded_time" [matTooltip]="getFullTimestamp(att.uploaded_time)">
                                    {{ getRelativeTime(att.uploaded_time) }}
                                </span>
                            </div>
                        </div>
                        <div class="att-item-actions">
                            <button type="button" class="att-action-btn" (click)="downloadAttachment(att)"
                                matTooltip="Download">
                                <mat-icon>download</mat-icon>
                            </button>
                            <button type="button" class="att-action-btn delete" (click)="deleteAttachment(att)"
                                [disabled]="isDeletingAttachmentId === att.attachment_id" matTooltip="Delete">
                                <mat-icon>{{ isDeletingAttachmentId === att.attachment_id ? 'hourglass_empty' :
                                    'delete_outline' }}</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Empty state (loaded, no files yet). The drop zone above
                     stays visible so the user can still add files. -->
                <div *ngIf="!isLoadingAttachments && getTaskId() && taskAttachments.length === 0" class="att-empty">
                    <mat-icon class="att-empty-icon">folder_open</mat-icon>
                    <p>No attachments yet — drop files above to upload.</p>
                </div>

            </div>
        </div>
    </ng-container>


</section>